// src/components/MainLayout.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';
import { useLocation } from 'react-router-dom';
import { CalendarioProvider, useCalendario } from '../contexts/CalendarioContext';
import Navegacion from './NavegacionLateral';
import NavegacionMobile from './mobile/NavegacionMobile';
import useBreakpoint from '../hooks/useBreakpoint';
import RightPanelTools from './RightPanelTools';
import PushNotificationContainer from './PushNotificationContainer';
import WhatsAppIncomingMonitor from './WhatsAppIncomingMonitor';
import ModalAnuncioSistema from './ModalAnuncioSistema';
import anuncioSistemaService from '../services/anuncioSistemaService';
import WhatsAppDesconexionAlert from './WhatsAppDesconexionAlert';
import { listarTiposTurno } from '../services/tipoTurnoService';
import { registrarCatalogoTipos } from '../constants/tiposTramiteTurno';

const MainLayoutContent = ({ children }) => {
    const { user } = useAuth();
    const location = useLocation();
    const { calendarioAbierto } = useCalendario();
    const [anuncioPendiente, setAnuncioPendiente] = useState(null);
    const { esMobile } = useBreakpoint();

    // Catálogo de tipos de turno: se carga una vez por sesión y queda cacheado, para que el
    // color y la etiqueta del badge salgan del catálogo en todas las pantallas (turnero, panel
    // diario, atención, TV) sin que cada una tenga que pedirlo.
    useEffect(() => {
        if (!user) return;
        listarTiposTurno(false)
            .then(registrarCatalogoTipos)
            .catch(() => {}); // si falla, las pantallas usan el respaldo local
    }, [user]);

    useEffect(() => {
        if (!user) return;
        anuncioSistemaService.obtenerPendiente()
            .then(anuncio => { if (anuncio) setAnuncioPendiente(anuncio); })
            .catch(() => {}); // no interrumpir el flujo si falla
    }, [user]);

    const handleEntendido = async () => {
        try {
            await anuncioSistemaService.marcarVisto();
        } finally {
            setAnuncioPendiente(null);
        }
    };

    // No renderizamos el layout si no hay usuario
    if (!user) {
        return null;
    }

    return (
        <div className="main-layout">
            {esMobile ? <NavegacionMobile /> : <Navegacion />}
            <RightPanelTools />
            <PushNotificationContainer />
            <WhatsAppIncomingMonitor />
            <WhatsAppDesconexionAlert />
            <ModalAnuncioSistema anuncio={anuncioPendiente} onEntendido={handleEntendido} />
            <div className="container mt-4">
                {children}
            </div>
        </div>
    );
};

const MainLayout = ({ children }) => {
    return (
        <CalendarioProvider>
            <MainLayoutContent>{children}</MainLayoutContent>
        </CalendarioProvider>
    );
};

export default MainLayout;
